import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * This interceptor automatically adds the token header needed by our backend API if such token is present
 * in the current state of the application.
 */
@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor( private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newHeaders = req.headers;
    if (localStorage.getItem('xVal')) {// xVal is our token name
      newHeaders = newHeaders.set('Authorization', localStorage.getItem('xVal'));
    }

    const authReq = req.clone({headers: newHeaders});
    return next.handle(authReq).pipe(catchError((error, caught) => {
      //intercept the respons error and displace it to the console
      this.handleAuthError(error);
      return of(error);
    }) as any);
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    if (err.status === 401) { // status 401 is added by web api when valid token is not present
      localStorage.setItem('xVal', '');
      this.router.navigate(['/login']);
      return of(err.message);
    }
    throw err;
  }
}
